import axios from 'axios';
import { FETCH_MENU_CATEGORIES_WITH_MENU_ITEMS } from './types';
import { BASE_URL } from '../components/utils/misc';

export const fetchMenuCatgoriesWithMenuItems = () => async dispatch => {
  const res = await axios.get(`${BASE_URL}/api/web/fetch-menu-categories-with-menu-items/true`);
  
  dispatch({ type: FETCH_MENU_CATEGORIES_WITH_MENU_ITEMS, payload: res.data });
};
